import React, { createContext, ReactNode, useContext } from "react";
import { RecEndpoint } from "../../server/constants.js";
import { ExternalProps } from "../../types.js";

const context = createContext<ExternalProps>({
	proxyUrl: "",
	locale: "nb",
	favoriteBaseUrl: "",
	parameters: { subvertical: RecEndpoint.Car, variant: "pagination" },
});

export const ExternalPropsProvider = (props: ExternalProps & { children?: ReactNode }) => {
	const { children, ...externalProps } = props;
	return <context.Provider value={externalProps}>{children}</context.Provider>;
};

export const useExternalProps = () => {
	return useContext(context);
};
